var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progressbar"},[_c('div',{staticClass:"shadow w-full progress"},[_c('div',{staticClass:"bg-progress text-xs leading-none py-1 text-center",style:(("width: " + _vm.value + "%"))},[_vm._v(_vm._s(_vm.value)+"%")])])])}
var staticRenderFns = []

export { render, staticRenderFns }